import React from 'react'
import { Row, Col, Button } from 'reactstrap'

export default function ItemSubmit (props) {
  return (
    <Row>
      <Col>
        <Button 
          onClick={props.handleSubmit} 
          outline={!props.active} 
          disabled={!props.active} 
          color={props.active ? 'primary' : 'secondary'} 
          className='btn-block'
        >
          Submit
        </Button>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentItemView/ItemSubmit.js